import styled from "styled-components";

export const AdminBody = styled.div`
    display: flex;
`

export const AdminContent = styled.div`
    flex: 1;
    padding: 20px;
    padding-bottom: 200px;
`

export const PageTitle = styled.h2`
    color: #333;
    margin-bottom: 10px;
`